import { useCallback, useState } from "react";

type UseSiteSurveyCancelFlowOptions = {
  cancelAppointment: (reason: string) => Promise<unknown>;
  onCancelModalClose: () => void;
};

const useSiteSurveyCancelFlow = ({
  cancelAppointment,
  onCancelModalClose,
}: UseSiteSurveyCancelFlowOptions) => {
  const [cancelApptReason, setCancelApptReason] = useState<string>();

  const onUnschedule = useCallback(
    (reason: string) => {
      return cancelAppointment(reason)
        .catch(() => {
          setCancelApptReason(reason);
        })
        .finally(() => {
          onCancelModalClose();
        });
    },
    [cancelAppointment, onCancelModalClose]
  );

  const clearCancelError = useCallback(() => {
    setCancelApptReason(undefined);
  }, []);

  return {
    cancelApptReason,
    onUnschedule,
    clearCancelError,
    showCancelError: cancelApptReason != null,
  };
};

export { useSiteSurveyCancelFlow };
